import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const LoadMoreListWrapper = styled.div`
  .load-more-container {
    margin: 24px 16px;

    .load-more-button {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${COLORS.primary_light_blue};
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
